import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { AppShell } from '@/components/layout/AppShell'
import { appSearchDefaults, appSearchSchema } from '@/components/search/appSearchSchema'

export const Route = createFileRoute('/')({
  validateSearch: appSearchSchema,
  // Drop params that equal their default from the URL (clean, shareable links).
  search: { middlewares: [stripSearchParams(appSearchDefaults)] },
  component: AppShell,
})
